export enum EnumMonitoringSLO {
    MONTHLY = 'MONTHLY',
    BIMESTRIAL = 'BIMESTRIAL',
    QUARTERLY = 'QUARTERLY',
    FOURMONTHLY = 'FOURMONTHLY',
    SEMIANNUAL = 'SEMIANNUAL',
    YEARLY = 'YEARLY',
}
